export const SlidersTableColumns = (isArabic) => [
    { id: 'title', label: isArabic ? 'العنوان' : 'Title', align: 'start' },
    { id: 'sup_title', label: isArabic ? 'العنوان الفرعي' : 'Subtitle', align: 'start' },
    { id: 'is_active', label: isArabic ? 'الحالة' : 'Status', align: 'start' },
    { id: 'created_at', label: isArabic ? 'تاريخ الإضافة' : 'Created At', align: 'start' },
];